module.exports = __webpack_public_path__ + "img/65400.77bbf1f8.jpg";